var map = {
	"./Aggressive/overallSkills.json": [
		1459,
		459
	],
	"./Conservative/overallSkills.json": [
		5894,
		894
	],
	"./PulseCast/overallSkills.json": [
		303,
		303
	],
	"./Realistic/overallSkills.json": [
		8129,
		129
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3498;
module.exports = webpackAsyncContext;